import React from "react";
import { Container } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import DTNAPPFeatures from "../DTNAPP/DTNAPPFeatures";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import APPBenefit from "../APPBenefits/APPBenefit";
import Icon3 from "../../images/app4.png";
import Icon8 from "../../images/talking.svg";
import { NavLink } from "react-router-dom";
// Main component for EdgeAISuperApp
export default function EdgeAISuperApp() {
  // Overview data sections
  const data1 = [
    "Hyper-local Supply Chain Orchestration: Ensures precise coordination and efficiency in agricultural logistics at the local level.",
    "Contract Farming Services: Integrates contract farming for streamlined agricultural operations.",
    "Contract Manufacturing Services: Optimizes production and supply chain management through contract manufacturing.",
  ];

  const data2 = [
    "Storage Service: Provides efficient storage management for agricultural inventory.",
    "Transportation Service: Facilitates seamless logistics in agricultural supply chains.",
  ];
  // List of apps associated with Edge AI Super App
  const apps = [
    { href: "/aamc-app", image: Icon3, title: "AAMC App" },
    { href: "/cbn-app", image: Icon8, title: "CBN App" },
    { href: "/ppn-app", image: Icon8, title: "PPN App" },
  ];

  return (
    <>
      <div className="businessPartnerContainer agristackContainer">
        <Container maxWidth="sm" className="gridSection gridSection--mod">
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            spacing={1}
          >
            {apps.map(({ href, image, title }, index) => (
              <Grid
                key={index}
                item
                md={2}
                sm={4}
                xs={6}
                className="hoverEffect mb-3"
              >
                <NavLink to={href}>
                  <img src={image} alt={`${title} View`} />
                  <h4>{title}</h4>
                </NavLink>
              </Grid>
            ))}
          </Grid>
        </Container>
      </div>

      {/*  Overview */}
      <SolutionEcosystem title="Overview" type="DTN" />

      {/*  Overview Feature*/}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/*  Features & Benefits Section */}
      <DTNAPPFeatures />
      <APPBenefit />
    </>
  );
}
